// Brand constants
export const LOGO_URL = "/logo.png";

// Full-body mascot illustrations (different expressions / poses)
// Locally hosted from /public/mascots — checker-pattern background removed
export const MASCOT = {
    thumbsUp: "/mascots/thumbs_up.png",
    cheering: "/mascots/cheering.png",
    jumping: "/mascots/jumping.png",
    smileClosedEyes: "/mascots/smile_eyes.png",
};

export const BRAND_NAME = "やさまる電電開発";
export const COMPANY_NAME = "株式会社フレッシュエージェント";
export const TAGLINE = "現場の仕事を、もっとラクにするシステム開発。";

// Mascot-only crop: the logo image has the mascot on the left ~25-30%.
// Using object-cover with object-position left to crop to mascot.
export function Mascot({ className = "w-16 h-16", alt = "やさまるくん" }) {
    return (
        <div
            className={`${className} relative overflow-hidden inline-block`}
            aria-hidden={alt === ""}
        >
            <img
                src={LOGO_URL}
                alt={alt}
                className="absolute inset-0 h-full object-cover"
                style={{
                    width: "auto",
                    aspectRatio: "1 / 1",
                    objectPosition: "0% center",
                    transform: "scale(2.1)",
                    transformOrigin: "12% center",
                }}
                draggable={false}
            />
        </div>
    );
}
